import { createSlice } from '@reduxjs/toolkit';
import { addFullPageLoaderHandler, addLoaderHandler, clearCustomerConfigHandler, removeFullPageLoaderHandler, removeLoaderHandler, resetGeneralToDefaultHandler, setCustomerConfigHandler, setDetectedCountryCodeHandler, setIsAuthorizedHandler, setIsCountryCompletedHandler, setIsFamilyMemberMinorHandler, setIsFamilyMemberRegisterRequestedHandler, setIsFirstSignUpHandler, setIsInErrorHandler, setIsInitializedHandler, setIsMemberRegistryCompletedHandler, setIsPlanCreated, setIsRedeemCouponHandler, setIsWalkThroughCompletedHandler, setMembersColors, setUserTimeZone, } from './general.reducer';
export var generalInitialState = {
    fullPageLoaders: [],
    isInError: false,
    loaders: [],
    isInitialized: false,
    isAuthorized: undefined,
    isCountryCompleted: undefined,
    redeemCoupon: undefined,
    isMemberRegistryCompleted: undefined,
    isWalkThroughCompleted: undefined,
    isFamilyMemberRegisterRequested: false,
    isFamilyMemberMinor: false,
    isPlanCreated: false,
    membersColors: {},
    isFirstSignUp: false,
    userTimezone: undefined,
    detectedCountryCode: null,
    customerConfig: null,
    customerConfigVersion: null,
};
var GENERAL_SLICE = 'generalSlice';
var generalSlice = createSlice({
    name: GENERAL_SLICE,
    initialState: generalInitialState,
    reducers: {
        addFullPageLoader: addFullPageLoaderHandler,
        removeFullPageLoader: removeFullPageLoaderHandler,
        addLoader: addLoaderHandler,
        removeLoader: removeLoaderHandler,
        setIsAuthorized: setIsAuthorizedHandler,
        setIsInitialized: setIsInitializedHandler,
        setIsInError: setIsInErrorHandler,
        resetGeneralToDefault: resetGeneralToDefaultHandler,
        setIsWalkThroughCompleted: setIsWalkThroughCompletedHandler,
        setIsCountryCompleted: setIsCountryCompletedHandler,
        setIsRedeemCoupon: setIsRedeemCouponHandler,
        setIsMemberRegistryCompleted: setIsMemberRegistryCompletedHandler,
        setIsFamilyMemberRegisterRequested: setIsFamilyMemberRegisterRequestedHandler,
        setIsFamilyMemberMinor: setIsFamilyMemberMinorHandler,
        setIsPlanCreated: setIsPlanCreated,
        setMemberColors: setMembersColors,
        setIsFirstSignUp: setIsFirstSignUpHandler,
        setUserTimezone: setUserTimeZone,
        setDetectedCountryCode: setDetectedCountryCodeHandler,
        setCustomerConfig: setCustomerConfigHandler,
        clearCustomerConfig: clearCustomerConfigHandler,
    },
});
export var GeneralActions = generalSlice.actions;
export var generalReducer = generalSlice.reducer;
